// @ts-strict-ignore
import type {
  PropsWithChildren,
  ReactElement,
} from 'react';
import React, {
  useMemo,
  useState,
} from 'react';
import { Modal, ModalBody } from 'reactstrap';
import ModalContext from './ModalContext';
import { StyledModalCloseButton } from './styles';
import type { ModalProps } from './types';

const ModalInstance = ({ children, onClose }: PropsWithChildren<ModalProps>) => (
  <Modal
    size="sm"
    isOpen={!!children}
    toggle={onClose}
    style={{ minWidth: 'max-content' }}
  >
    <StyledModalCloseButton
      type="button"
      className="close"
      aria-label="Close"
      onClick={onClose}
    >
      <i className="far fa-fw fa-times" />
    </StyledModalCloseButton>
    <ModalBody>{children}</ModalBody>
  </Modal>
);

const ModalProvider = ({ children }: PropsWithChildren<{}>) => {
  const [modal, setModal] = useState<ReactElement | null>(null);
  const [isComponentLibraryModal, setIsComponentLibraryModal] = useState(false);
  const value = useMemo(() => ({
    open: (content: ReactElement, options) => {
      if (options?.isComponentLibraryModal) {
        setIsComponentLibraryModal(true);
      }
      setModal(content);
    },
    close: () => {
      if (isComponentLibraryModal) setIsComponentLibraryModal(false);
      setModal(null);
    },
  }), [setModal, isComponentLibraryModal, setIsComponentLibraryModal]);

  return (
    <ModalContext.Provider value={value}>
      {
        isComponentLibraryModal
          ? modal
          : <ModalInstance onClose={value.close}>{modal}</ModalInstance>
      }
      {children}
    </ModalContext.Provider>

  );
};

export default ModalProvider;
